import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import OpportunitiesView from './view/OpportunitiesView';
import OpportunitiesDetails from './details/OpportunitiesDetails';

import buttons from './OpportunitiesButtons';
import events from './OpportunitiesEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('opportunities'),
	routes: [
		{
			path: 'opportunities/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'opportunities'),
			element: (
				<DetailsPage
					key="opportunities/add"
					module="opportunities"
					tabs={OpportunitiesDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'opportunities/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'opportunities'),
			element: (
				<DetailsPage
					key="opportunities/details"
					module="opportunities"
					tabs={OpportunitiesDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'opportunities/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'opportunities'),
			element: (
				<ViewPage
					key="opportunities/view"
					module="opportunities"
					content={{ type: 'tabs', tabs: OpportunitiesView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
